import { render, staticRenderFns } from "./SearchBreakdownsPage.vue?vue&type=template&id=31d6644e&"
import script from "./SearchBreakdownsPage.vue?vue&type=script&lang=js&"
export * from "./SearchBreakdownsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports